import { request } from "@frontend/lib/http";

import type { AddressMapPoint, RouteQuery, RouteSummary } from "../types";

type RequestOptions = { signal?: AbortSignal };

export function fetchAddressMap(
  addressId: number,
  options?: RequestOptions,
): Promise<AddressMapPoint> {
  return request({
    route: "api_typedaddresses_map",
    query: { typedAddressId: addressId },
    ...options,
  });
}

export function fetchRoute(
  { from, to, via = [], mode }: RouteQuery,
  options?: RequestOptions,
): Promise<RouteSummary> {
  return request({
    route: "api_geolocation_route",
    query: {
      from,
      to,
      via: via.length > 0 ? via.join(";") : undefined,
      mode,
    },
    ...options,
  });
}
